import React from "react";
import Content from "../../Components/Content/Content";
import { RiKey2Fill } from "react-icons/ri";
import Card from "../../Components/Card/Card";
import styles from "../Help/Help.module.scss";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Result, Typography } from "antd";
import { FaVideo } from "react-icons/fa";

const { Paragraph, Text } = Typography;

const Help: React.FC = () => {
  return (
    <Content>
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-sm col-md-12 col-lg-12 mt-3"}>
            <Card
              id={"card1"}
              width={"100%"}
              image={RiKey2Fill}
              header={"Help"}
            >
              <Result
                status="404"
                title="In Progress"
                subTitle="If you require assistance please contact WiLine Support (1-888-494-5463)"
              >
                {/*<div className="desc">
                  <Paragraph>
                    <Text
                      strong
                      style={{
                        fontSize: 16,
                      }}
                    >
                      For video guides, please visit these links:
                    </Text>
                  </Paragraph>
                  <Paragraph>
                    <FaVideo className={styles.listIcon} />
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.youtube.com/playlist?list=PLdol10fN_KXnth4-KYbtsCCr8Nk4rxX0h"
                    >
                      {" "}
                      Wiline Connect End User Playlist
                    </a>
                  </Paragraph>
                </div>*/}
              </Result>

              <span></span>
            </Card>
          </div>
        </div>
      </div>
    </Content>
  );
};

export default Help;
